// import ENGLISH from '../translations/english'
import SPANISH from '../translations/spanish'

const t = (text, ...params) => {
  const parts = text.split('.')
  let translation = parts.reduce((translations, part) => {
    return translations[part] ? translations[part] : false
  }, SPANISH)

  if (!translation) translation = text

  if (params || params.length > 0) {
    params.forEach((param) => {
      translation = translation.replace("%s", param.toString())
    })
  }
  return translation
}

export default t